module.exports = __webpack_public_path__ + "img/waldorf-salad.426e6a14.jpg";